import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { saveOCTableViewColumns } from '../data-provider/table-view-columns';
import type { SaveOCTableViewColumnsData } from '../data-provider/table-view-columns/api';

export interface UseSaveOCTableViewColumnsOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useSaveOCTableViewColumns = (options?: UseSaveOCTableViewColumnsOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SaveOCTableViewColumnsData) => saveOCTableViewColumns(data),
    onError: (error: Error) => {
      showNotification({
        message: 'Failed to save Overcharge claims columns Options',
        type: NOTIFICATION_TYPES.ERROR,
      });
      options?.onError?.(error);
    },
    onSuccess: (_data, variables) => {
      queryClient.setQueryData(
        ['claims-over-charge-table-view-columns', variables.gridName],
        (oldData: { columnName: string; columnValue: string; id: string }[] | undefined) => {
          if (!oldData) {
            return oldData;
          }
          return variables.columnOptions.map(({ fieldReferenceName, fieldReferenceValue }) => ({
            columnName: fieldReferenceName,
            columnValue: fieldReferenceValue,
            id: oldData.find((row) => row.columnValue === fieldReferenceValue)?.id ?? fieldReferenceValue,
          }));
        },
      );

      showNotification({
        message: 'Successfully saved Overcharge claims columns Options',
        type: NOTIFICATION_TYPES.SUCCESS,
      });

      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
};
